"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegisterIcon = exports.getFriendlyLabel = void 0;
//TODO: remove this as timeofuselabel is adopted in more display places
var getFriendlyLabel = function (timingCategory) {
    switch (timingCategory) {
        case 'EVENING_AND_WEEKEND':
            return 'EveningAndWeekend';
        case 'HEATING':
            return 'Heating';
        case 'OFF_PEAK':
            return 'Offpeak';
        case 'PEAK':
            return 'Peak';
        case 'SOLAR':
            return 'Solar';
        case 'INTERVAL':
            return 'Interval';
        case 'CONTROLLED_LOAD_1':
        case 'CONTROLLED_LOAD_2':
        case 'CONTROLLED_LOAD_3':
            return 'Controlled Load';
        case 'SHOULDER':
            return 'Shoulder';
        // fall back to anytime if there's an unknown supply type - otherwise the tab is blank and looks obviously broken
        case 'ANYTIME':
        default:
            return 'Anytime';
    }
};
exports.getFriendlyLabel = getFriendlyLabel;
var getRegisterIcon = function (timingCategory) {
    switch (timingCategory) {
        case 'EVENING_AND_WEEKEND':
            return 'evening-and-weekend';
        case 'HEATING':
            return 'heating';
        case 'OFF_PEAK':
            return 'offpeakLegacy'; // TODO: use new icons when we are ready.
        case 'PEAK':
            return 'peakLegacy'; // TODO: use new icons when we are ready.
        case 'ANYTIME':
            return 'anytime';
        default:
            return 'meter';
    }
};
exports.getRegisterIcon = getRegisterIcon;
